import privacy from "./privacy.md?raw";
import terms from "./terms.md?raw";

/** @typedef {{ slug: string; title: string; body: string }} LegalDoc */

/** @type {Record<string, LegalDoc>} */
export const legalDocuments = {
  privacy: {
    slug: "privacy",
    title: "Privacy Policy",
    body: privacy,
  },
  terms: {
    slug: "terms",
    title: "Terms and Conditions",
    body: terms,
  },
};

export function getLegalDoc(slug) {
  return legalDocuments[slug] ?? null;
}
